import WithOrgConfig from 'Components/SharedComponents/WithOrgConfig/WithOrgConfig'

const RootContainer = () => null

export default WithOrgConfig(RootContainer)
